import type { Buyer } from 'c-sdk';

/**
 * Whether the new-campaign form swaps its default reference rule (required, at least 3
 * characters) for the buyer's own rule. Extracted from `NewCampaignForm`.
 */
export const buyerHasReferenceRules = (buyer: Buyer | null | undefined): buyer is Buyer =>
    buyer != null && (buyer.reference_prefix != null || buyer.reference_type != null);

/** The buyer's reference rule: length within the buyer's min/max and starting with its prefix. */
export const isValidBuyerReference = (buyer: Buyer, value: string | null | undefined) => {
    const valLength = value?.length ?? 0;
    const minLength = buyer?.reference_min_length ?? 1;
    const maxLength = buyer?.reference_max_length ?? Infinity;

    const passedLength = valLength >= minLength && value != null && value.length <= maxLength;
    const passedPrefix = (value ?? '').startsWith(buyer?.reference_prefix ?? '');

    return passedLength && passedPrefix;
};
